import { Flex, Space, Title } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface SimpleStepDotsProps {
  step: number;
  max: number;
  text?: boolean;
}

export const SimpleStepDots: FC<SimpleStepDotsProps> = ({
  step,
  max,
  text = true,
}) => {
  const { t } = useTranslation('common');
  const stepList = [];

  for (let i = 0; i < max; i++) {
    if (i !== step - 1) {
      stepList.push(
        <div
          key={i}
          style={{
            height: '8px',
            width: '8px',
            backgroundColor: 'var(--mantine-color-otherGrey30-0)',
            borderRadius: '50%',
            margin: '2px',
          }}
        />,
      );
    } else {
      stepList.push(
        <div
          key={i}
          style={{
            height: '8px',
            width: '20px',
            backgroundColor: 'var(--mantine-primary-color-filled)',
            borderRadius: '4px',
            margin: '2px',
          }}
        />,
      );
    }
  }

  return (
    <Flex direction={'column'}>
      <Flex
        style={{ marginBottom: '4px' }}
        direction={'row'}
        justify={'center'}
      >
        {stepList}
      </Flex>
      {text ? (
        <Title
          style={{ color: 'var(--mantine-color-otherGrey60-0)' }}
          order={3}
        >
          {t('step')} {step}/{max}
        </Title>
      ) : (
        <Space h={'var(--mantine-spacing-xs)'} />
      )}
    </Flex>
  );
};
